<script>
import sl from '@/Prevodi/Camo-sl.json';
import en from '@/Prevodi/Camo-en.json';
import it from '@/Prevodi/Camo-it.json';
import {i18n} from "@/i18n";
import {config} from "@/config";
export default {
  name: "Camo",
  data() {
    return {
      prevodi: false,
      userLvl: config.UserLVL
    }
  },
  created() {
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
    this.prevodi = true;
  },
  mounted() {
    if(this.userLvl !== 6 && (this.userLvl > 1 && this.userLvl < 6)) {
      this.$router.push('/');
    }
  },
  methods: {
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
  }
}
</script>

<template>
  <div class="pregled-povrsin-container" v-if="prevodi && (userLvl === 6 || userLvl <= 1)">
    <!-- Modern Header -->
    <div class="modern-header">
      <div class="header-content">
        <!-- Back Button -->
        <div class="header-section header-left">
          <button class="back-btn" @click.prevent="$router.push('/')">
            <i class="fas fa-arrow-left"></i>
            <span>Nazaj</span>
          </button>
        </div>
        <!-- Title -->
        <div class="header-section header-center">
          <h1 class="page-title"> {{ $t('main.title') }}</h1>
          <!-- <p class="page-subtitle">Obrazec št. 1 - Poročilo o pregledu površin za gibanje zrakoplovov</p> -->
        </div>
      </div>
    </div>
  </div>
  <main class="main-content">
    <!-- Main Menu Section -->
    <div class="menu-section">
      <div class="menu-grid">
        <!-- Plovila -->
        <div class="menu-card" @click="$router.push('/pregledi/CamoPlovila')">
          <div class="menu-icon">
            <i class="fas fa-plane"></i>
          </div>
          <div class="menu-content">
            <h3 class="menu-title"> {{ $t('menu.plovila.title') }} </h3>
            <p class="menu-description">{{ $t('menu.plovila.description') }}</p>
          </div>
        </div>

        <!-- Štartne liste -->
        <div class="menu-card" @click="$router.push('/pregledi/CamoStartne')">
          <div class="menu-icon">
            <i class="fas fa-file-alt"></i>
          </div>
          <div class="menu-content">
            <h3 class="menu-title"> {{ $t('menu.liste.title') }} </h3>
            <p class="menu-description">{{ $t('menu.liste.description') }}</p>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>